'use strict';

const version = process.env.VERSION;
const appVersion = 'not-set';

const neptuneApiBasePath = 'localhost';
const neptuneApiSecure = window.location.protocol === 'https:';
const neptuneApiPort = '8000';
const neptuneCookieDomain = 'neptune.ai';

const blogURL = 'https://neptune.ai/blog';
const documentationURL = 'https://poseidon.mai.microsoft.com/userdocs';
const integrationQuickStartURL = documentationURL;
const onpremInternalDocsURL = documentationURL;
const wwwUrl = 'https://neptune.ai';
const roadmapUrl = 'https://portal.neptune.ai/tabs/15-planned';
const onPremReleaseNotesUrl = 'https://onprem.neptune.ai/';
const contactEmail = 'contact@neptune.ai';
const salesEmail = 'sales@neptune.ai';
const supportEmail = 'support@neptune.ai';
const supportUrl = 'https://microsoft-si.slack.com/archives/C0AJEQDQW95';
const helloWorldCollabUrl =
  'https://colab.research.google.com/github/neptune-ai/examples/blob/master/how-to-guides/hello-world/notebooks/Neptune_hello_world.ipynb';
const pricingFaqURL = 'https://neptune.ai/pricing#faq';
const termsOfServiceUrl = 'https://neptune.ai/terms-of-service';
const privacyPolicyUrl = 'https://neptune.ai/privacy-policy';
const pricingURL = 'https://neptune.ai/pricing';

const logoutURL = '/';

const allowAddingNewLicense = false;

// we assume that port of Websockets is always the same as rest API port,
// if this will change then it should be delivered as part of docker config
const neptuneApiWSPort = neptuneApiPort;

const keycloakURL = '/auth';
const keycloakRealm = 'neptune';
const keycloakFrontendClientId = 'neptune-frontend';
const keycloakEmbedClientId = 'slack-embed';
const enableKeycloakLogging = false;
const rateLimiterThrottleThreshold = 0.3;

// It's default setting for condensed mode, it can be configured in docker config
const condensedModeEnabled = false;

/* Default visibility of object-table fields, it can be configured in docker config */
const defaultVisibleObjectTableFields =
  'sys/name,sys/creation_time,sys/owner,sys/tags,sys/group_tags,sys/description';

/* Default pinned status of object-table fields, it can be configured in docker config */
const defaultPinnedObjectTableFields = 'sys/name,sys/creation_time';

const withNewEmptyState = true;
const hideRunSize = true;
const hideMonitoringTime = true;
const disableRemoteRunActions = true;
const disableNotSupportedWidgets = true;
const withDisabledTrashing = true;
const udfSandboxEnabled = false;

const allowUserActionsTracking = false;
const pulseCheckSurveyCampaignId = 'default';

/* JSON map of dashboard versionBranchId to usernames allowed to lock or unlock it, it can be configured in docker config */
const dashboardLockEditors = '{}';

/* JSON map of dashboard versionBranchId to usernames allowed to modify it, it can be configured in docker config */
const dashboardEditors = '{}';

const limits = {
  fileSetPreviewFilesLimit: 1000,
  fileSetDownloadLimit: 1000,
  objectTableObjectsLimit: 10000,
  maxChartsWidgetsDisplayed: 1000,
  maxImagesWidgetsDisplayed: 1000,
  versionsDropdownPageLimit: 100,
  chartMaxMetricsLimit: 1000,
  previewWidgetsLimit: 300,
  previewWidgetsPageSize: 100,
};

// Settings configured here will be merged into the final config object.
export default {
  isProduction: false,
  neptuneCookieDomain,
  contactEmail,
  salesEmail,
  supportEmail,
  supportUrl,
  blogURL,
  helloWorldCollabUrl,
  documentationURL,
  integrationQuickStartURL,
  onpremInternalDocsURL,
  wwwUrl,
  pricingFaqURL,
  pricingURL,
  roadmapUrl,
  onPremReleaseNotesUrl,
  logoutURL,
  allowAddingNewLicense,
  keycloakURL,
  keycloakRealm,
  keycloakFrontendClientId,
  keycloakEmbedClientId,
  enableKeycloakLogging,
  rateLimiterThrottleThreshold,
  neptuneApiBasePath,
  neptuneApiPort,
  neptuneApiWSPort,
  neptuneApiSecure,
  version,
  appVersion,
  termsOfServiceUrl,
  privacyPolicyUrl,
  condensedModeEnabled,
  defaultVisibleObjectTableFields,
  defaultPinnedObjectTableFields,
  withNewEmptyState,
  hideRunSize,
  hideMonitoringTime,
  disableRemoteRunActions,
  disableNotSupportedWidgets,
  withDisabledTrashing,
  udfSandboxEnabled,
  allowUserActionsTracking,
  pulseCheckSurveyCampaignId,
  dashboardLockEditors,
  dashboardEditors,
  ...limits,
};
